import { useAuth } from "@/auth/AuthProvider";
import AdminSidebarMenuItems from "./AdminSidebarMenuItems";
import ClinicalCoderSidebarMenuItems from "./ClinicalCodeSidebarMenuItems";

const SideMenuItemsForRole = () => {
  const { role } = useAuth();

  const SidebarMenuItems = role === "admin" ? AdminSidebarMenuItems : ClinicalCoderSidebarMenuItems;

  return <SidebarMenuItems />;
};

export default SideMenuItemsForRole;
